import _ from 'lodash';
import customFilterColumnsExtend from '../custom_filter_columns_extend';
import { columnsExtend as entityColumnsExtend, formColumnsExtend as entityFormColumnsExtend } from '../admin_entities/customer_connection_detail.js';
import { shareColumnsExtend } from './share';
export const filterColumns = {
  name_cont: {
    model_name: 'CustomerConnection',
    column_type: 'string',
    column_name: 'name',
  },
}
export const formColumnsConfig = {
  'self': {
    'name': { required: true, disabledUpdate: false },
  },
}

export const filterColumnsExtend = (columns) => {
  const customColumns = customFilterColumnsExtend(filterColumns)

  return columns.map(hash => {
    if (typeof hash === 'string') {
      return customColumns[hash]
    } else if (hash['key']) {
      return _.merge(customColumns[hash['key']], hash)
    } else {
      return hash
    }
  })
}

export const columnsExtend = (columns) => {
  return entityColumnsExtend(shareColumnsExtend('CustomerConnection', columns))
}

export const formColumnsExtend = (columns, { data, type }) => {
  return _.map(entityFormColumnsExtend(shareColumnsExtend('CustomerConnection', columns), { data, type, formColumnsConfig: formColumnsConfig['self'] }))
}
